export interface ProjectCompany {
  company: {
    id: string;
    name: string;
  };
  badgeId?: string;
  projectBadgeTemplateId?: string;
  badgeStatus?: number;
}
export interface ProjectDetails {
  id: string;
  name: string;
  logoUrl?: string;
}

export interface Project {
  workerProjectStatus: number;
  companies: ProjectCompany[];
  project: ProjectDetails;
  projectStatus: number;
  lastModifiedAt: string;
  createdAt?: string;
}

export enum ProjectStatus {
  PAST_PROJECT = 'PAST_PROJECT',
  PENDING_PROJECT = 'PENDING_PROJECT',
  CURRENT_PROJECT = 'CURRENT_PROJECT',
}

// API Project Status enum values
export enum ApiProjectStatus {
  PENDING = 1,
  ACTIVE = 2,
  CLOSED = 3,
}

// Worker Project Status enum values
export enum WorkerProjectStatus {
  PENDING = 0,
  ACTIVE = 1,
  INACTIVE = 2,
}

export enum TabIndex {
  PENDING = 0,
  CURRENT = 1,
  PAST = 2,
  ALL = 3,
}

export enum SortType {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
}
